module.exports = __webpack_public_path__ + "img/孙亚男.8773f14e.jpg";